export default [
  {
    path: '/select-refund',
    name: 'SelectRefund',
    component: () => import('../../pages/refunds/selectGoods.vue'),
    meta: {
      title: '选择商品列表'
    }
  },
  {
    path: '/add-refund-express',
    name: 'AddRefundExpress',
    component: () => import('../../pages/refunds/addRefundExpress.vue'),
    meta: {
      title: '填写退货物流'
    }
  },
  {
    path: '/select-company',
    name: 'SelectCompany',
    component: () => import('../../pages/refunds/selectCompany.vue'),
    meta: {
      title: '选择快递公司'
    }
  },
  {
    path: '/refund-list',
    name: 'Refund-list',
    component: () => import('../../pages/refunds/list.vue'),
    meta: {
      title: '退款单列表'
    }
  },
  {
    path: '/refund/:id',
    name: 'refundDetail',
    component: () => import('../../pages/refundsDetail/index.vue'),
    meta: {
      title: '退款详情',
      telescope: 'zyjk-page-mzyjk-mall-OrderDetails'
    }
  },
  {
    path: `/refund-apply`,
    name: 'refundApply',
    component: () => import('../../pages/refunds/index.vue'),
    meta: {
      title: '申请退款'
    }
  }
];
